import { AxiosPromise } from 'axios';
import { IGetGroup, IGetGroups, IGetTiDuties, IGroupReq } from '../models/groups.model';
import axios from 'axios';

const uri = '/mgmt/groups';

export const getGroups = (): AxiosPromise<IGetGroups> => {
  return axios.get(uri);
}

export const getGroup = (id: number): AxiosPromise<IGetGroup> => {
  return axios.get(`${uri}/${id}`);
}

export const createGroup = (data: IGroupReq): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateGroup = (id: number, data: IGroupReq): AxiosPromise => {
  return axios.put(`${uri}/${id}`, data);
};

export const getTiDuties = (): AxiosPromise<IGetTiDuties> => {
  return axios.get(`${uri}/duties`);
}
